//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const SaveAtSubmitting: FeatureFlag = {"Id":"SaveAtSubmitting","Label":"(Technical)SaveAtSubmitting","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Save twice - once on entering submitter and once on advancing to the next form/wait","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
